import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { DraftsSelector } from 'features/drafts';
import {
  JOB_ORDER_DRAFTS_COLUMNS,
  NEW_JOB_ORDER_ENDPOINTS,
  ORDER_BY_OPTIONS
} from 'features/new-job-order/constants';
import { usePageTitle } from 'hooks';
import strings from 'strings';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';
import { PageTitles } from 'UI/constants/defaults';
import { EntityType, JobOrderEntity } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

import { NewJobOrderDataLoader } from '../NewJobOrderDataLoader';

/**
 * @typedef {Object} NewJobOrderProps
 * @property {*} history
 * @property {*} location
 */
export const NewJobOrderPage = props => {
  usePageTitle({ title: PageTitles.JobOrderCreate });
  const [selectedDraftId, setSelectedDraftId] = useState(null);
  const [activeDraftId, setActiveDraftId] = useState(null);
  const [deletedDraftId, setDeletedDraftId] = useState(null);
  const [draftsRefreshKey, setDraftsRefreshKey] = useState(0);
  const [formKey, setFormKey] = useState(0);

  const handleSelectDraft = draft => {
    const draftId = draft?.id ?? null;
    setSelectedDraftId(draftId);
    setActiveDraftId(draftId);
    setDeletedDraftId(null);
    setFormKey(prev => prev + 1);
  };

  const handleResetForm = () => {
    setSelectedDraftId(null);
    setActiveDraftId(null);
    setDeletedDraftId(null);
    setFormKey(prev => prev + 1);
  };

  const handleDraftDeleted = draft => {
    if (draft?.id === activeDraftId) setDeletedDraftId(draft.id);
  };

  const handleDraftSaved = draftId => {
    setActiveDraftId(draftId);
    setDeletedDraftId(null);
    setDraftsRefreshKey(prev => prev + 1);
  };

  return (
    <ContentPageLayout
      text={strings.inventory.jobOrders.create.newJobOrder.title}
      titleLabelProps={{ backNavigation: true }}
    >
      <Box marginTop={2} marginBottom={4}>
        <DraftsSelector
          columns={JOB_ORDER_DRAFTS_COLUMNS}
          endpoint={NEW_JOB_ORDER_ENDPOINTS.drafts}
          entity={EntityType.Joborder}
          entityLabel={JobOrderEntity.singular}
          onDraftDeleted={handleDraftDeleted}
          onSelectDraft={handleSelectDraft}
          orderByOptions={ORDER_BY_OPTIONS}
          pageKey={PERSISTENCE_KEYS.CREATION.JOB_ORDER_DRAFTS}
          refreshKey={draftsRefreshKey}
        />
      </Box>

      <Box marginTop={2}>
        <NewJobOrderDataLoader
          key={formKey}
          deletedDraftId={deletedDraftId}
          draftId={selectedDraftId}
          onDraftSaved={handleDraftSaved}
          onResetForm={handleResetForm}
          {...props}
        />
      </Box>
    </ContentPageLayout>
  );
};
